<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<!-- <Button type="primary" @click="add">新增</Button>
			<Button type="info" @click="cold">冷藏/常温</Button>
			<Button type="success" @click="start">启用/禁用</Button> -->
		</div>
		<!-- <div class="btn">
			<RadioGroup v-model="animal">
				<Radio label="列表"></Radio>
				<Radio label="地图"></Radio>
			</RadioGroup>
		</div> -->
		<div  class="lb">
			<!-- <div class="query">
				<div class="checkbox">
					<Select v-model="query.macKind" style="width:200px" @on-change="onchange" placeholder="设备分类">
					        <Option value="SHJ" >售货机</Option>
					        <Option value="KFJ" >咖啡机</Option>
					        <Option value="null" >不限</Option>
					</Select>
					<Select v-model="query.startUsing" style="width:200px" @on-change="onchange" placeholder="停用/启用">
					        <Option value="true" >启用</Option>
					        <Option value="false" >停用</Option>
					        <Option value="null" >不限</Option>
					</Select>
					<Select v-model="query.state" style="width:200px" @on-change="onchange" placeholder="正常/故障">
					        <Option value="true" >正常</Option>
					        <Option value="false" >故障</Option>
					        <Option value="null" >不限</Option>
					</Select>
				</div>
				<Input search enter-button placeholder="请输入地址/名称查询"  v-model="query.like" style="width: 500px;" @on-search="onsearch" />
			</div> -->
			<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
				<template slot-scope="{ row, index }" slot="action">
					<Button size="small" style="margin-right: 5px" @click="xinz(row.id)" type="primary" v-if="row.waimai!='shi'">分配</Button>
					<Button size="small" style="margin-right: 5px" @click="remove(row.id)" type="error" v-else>删除</Button>
					
				</template>
			</Table>
			<div class="my-page">
				<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				animal: '列表',
				
				//查询条件
				wd: [],
				zt: [],
				gz: [],
				loading: false,
				total: 100,
				query: {
					page: 0,
					size: 10,
					id: '' ,//加盟商id
					like:'',
					macKind:'',
					startUsing:'',
					state:'',
					empId:''
				},
				columns12: [{
						title: '设备编号',
						key: 'id',
						width: 150,
                        fixed: 'left',
					}, 
					{
						title: '分类',
						key: 'macKindstString',
					},
					{
						title: '名称',
						key: 'macDetailsName',
					},
					{
						title: '标识1',
						key: 'uuid1',
					},
					{
						title: '标识2',
						key: 'uuid2',
					},
					{
						title: '位置',
						key: 'address',
					},
					{
						title: '停用/启用',
						key: 'startUsing',
						render: (h, params) => {
							if (params.row.startUsing == true) {
								return h("div", "启用")
							} else {
								return h("div",{style:{color:'red'}},"停用") 
							}
						},
					},
					{
						title: '是否故障',
						key: 'state',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "正常")
							} else {
								return h("div",{style:{color:'red'}},"故障") 
							}
						},
					},
					{
						title: '录入时间',
						key: 'createdTime',
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center',
                        fixed: 'right',
					}
				],
				data6: [],
				deleteId: '',
				modal2: false,
				modal_loading: false,

			}
		},
		methods: {
			
			setRegion(regionId){
				this.query.regionId=regionId
				if(regionId!=undefined && regionId!="不限"){
					this.ajaxPage()
					this.ajaxPageDitu()
				}
				
			},
			onsearch(){
				let _this=this
				_this.ajaxPage()
			},
			selectionChange(selections) { //选中项发生变化时就会触发
				console.log(selections)
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			xinz(id) { //删除
			    let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/plat/jm/emp/waimai/jm/add',
					data: {macId: id,empId:_this.query.empId},
					_this: _this,
					success: function(data) {
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			remove(id) { //删除
			    let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/plat/jm/emp/waimai/jm/delete',
					data: {macId: id,empId:_this.query.empId},
					_this: _this,
					success: function(data) {
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			onchange(){
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/jm/emp/waimai/jm/queryAll',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.loading = false
						_this.total = data.macs.totalElements
						_this.data6 = data.macs.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		components: {
			page
		},
		created() {
			let id=this.$route.query.id
			this.query.empId=id
			this.ajaxPage()
			//this.ajaxPageDitu()
			
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/waimai/listMacAll.vue